import React, { useState, useRef, useEffect } from 'react';
import {
  Col,
  Row,
  Card,
  Input,
  Switch,
  Checkbox,
  Collapse,
  Modal,
  Select,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  SpText, SpButton, SpError,
} from 'components/DesignKit';
import {
  PAGES,
} from 'appconstants';
import Loading from 'components/Loading';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { cloverWebhookActions } from 'store/actions';

type Props = {
  loader: boolean,
  validator: boolean,
  cloverWebhook: Object,
  fetchCloverWebhook: Function,
  updateCloverWebhook: Function,
  addBulkImportWebHook: Function,
};

const InternalCloverWebHook = (props: Props) => {
  const {
    loader,
    cloverWebhook,
    fetchCloverWebhook,
    updateCloverWebhook,
    addBulkImportWebHook,
    validator,
  } = props;
  const { Option } = Select;
  const history = useHistory();
  const [, forceUpdate] = useState();
  const [redirect, setRedirect] = useState(false);
  const [confirmBulkImport, setConfirmBulkImport] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  // api credentials
  const [merchantId, setMerchantId] = useState((cloverWebhook && cloverWebhook.merchantId) || '');
  const [token, setToken] = useState((cloverWebhook && cloverWebhook.apiToken) || '');
  const [ecomApiToken, setEcomApiToken] = useState((cloverWebhook && cloverWebhook.ecomApiToken) || '');
  const [apiKey, setApiKey] = useState((cloverWebhook && cloverWebhook.apiKey) || '');
  // manage inventory
  const [manageInventory, setManageInventory] = useState((cloverWebhook && cloverWebhook.manageCloverInventory) || 'NONE');
  // eslint-disable-next-line max-len
  const [allowBulkImport, setAllowBulkImport] = useState((cloverWebhook && cloverWebhook.manageCloverInventory && cloverWebhook.manageCloverInventory !== 'MANAGE_ALL'));
  // manage webhooks
  const [enable, setEnable] = useState((cloverWebhook && cloverWebhook.enable) || false);
  const [allowInventory, setAllowInventory] = useState((cloverWebhook && cloverWebhook.allowInventory) || false);
  const [allowOrder, setAllowOrder] = useState((cloverWebhook && cloverWebhook.allowOrder) || false);
  // manage order config
  const [pushInventoryOrderToClover, setPushInventoryOrderToClover] = useState((cloverWebhook && cloverWebhook.pushInventoryOrderToClover) || false);
  const [pushOnlineOrderToClover, setPushOnlineOrderToClover] = useState((cloverWebhook && cloverWebhook.pushOnlineOrderToClover) || 'NONE');
  const [pushDineInOrderToClover, setPushDineInOrderToClover] = useState((cloverWebhook && cloverWebhook.pushDineInOrderToClover) || 'NONE');
  // eslint-disable-next-line max-len
  const [pushCloverNotificationForNonCloverOrders, setPushCloverNotificationForNonCloverOrders] = useState((cloverWebhook && cloverWebhook.pushCloverNotificationForNonCloverOrders) || false);
  // manage print config
  const [kitchenPrint, setKitchenPrint] = useState((cloverWebhook && cloverWebhook.kitchenPrint) || 'NONE');
  const [paymentPrint, setPaymentPrint] = useState((cloverWebhook && cloverWebhook.paymentPrint) || 'NONE');
  const [shouldBeTriggerPrint, setShouldBeTriggerPrint] = useState((cloverWebhook && cloverWebhook.shouldBeTriggerPrint) || false);
  // eslint-disable-next-line max-len
  const [printKitchenPrintAfterPayment, setPrintKitchenPrintAfterPayment] = useState((cloverWebhook && cloverWebhook.printKitchenPrintAfterPayment) || false);
  // eslint-disable-next-line max-len
  const [printPaymentPrintAfterPayment, setPrintPaymentPrintAfterPayment] = useState((cloverWebhook && cloverWebhook.printPaymentPrintAfterPayment) || false);

  const simpleValidator = useRef(new SimpleReactValidator());

  const addNewWebhook = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const params = {
      merchantId,
      apiToken: token,
      apiKey,
      ecomApiToken,
      manageCloverInventory: manageInventory,
      allowInventory,
      allowOrder,
      enable,
      pushInventoryOrderToClover,
      pushOnlineOrderToClover,
      pushDineInOrderToClover,
      pushCloverNotificationForNonCloverOrders,
      kitchenPrint,
      paymentPrint,
      shouldBeTriggerPrint,
      printKitchenPrintAfterPayment,
      printPaymentPrintAfterPayment,
    };
    updateCloverWebhook(params);
    setRedirect(true);
  };

  useEffect(() => {
    fetchCloverWebhook();
  }, []);

  useEffect(() => {
    if (cloverWebhook && cloverWebhook.gid) {
      setMerchantId(cloverWebhook && cloverWebhook.merchantId);
      setToken(cloverWebhook && cloverWebhook.apiToken);
      setApiKey(cloverWebhook && cloverWebhook.apiKey);
      setEcomApiToken(cloverWebhook && cloverWebhook.ecomApiToken);
      setManageInventory((cloverWebhook && cloverWebhook.manageCloverInventory) || 'NONE');
      setAllowBulkImport((cloverWebhook && cloverWebhook.manageCloverInventory && cloverWebhook.manageCloverInventory !== 'MANAGE_ALL'));
      setEnable((cloverWebhook && cloverWebhook?.enable) || false);
      setAllowInventory((cloverWebhook && cloverWebhook.allowInventory) || false);
      setAllowOrder((cloverWebhook && cloverWebhook.allowOrder) || false);
      setPushInventoryOrderToClover((cloverWebhook && cloverWebhook.pushInventoryOrderToClover) || false);
      setPushOnlineOrderToClover((cloverWebhook && cloverWebhook.pushOnlineOrderToClover) || 'NONE');
      setPushDineInOrderToClover((cloverWebhook && cloverWebhook.pushDineInOrderToClover) || 'NONE');
      setPushCloverNotificationForNonCloverOrders((cloverWebhook && cloverWebhook.pushCloverNotificationForNonCloverOrders) || false);
      setKitchenPrint((cloverWebhook && cloverWebhook.kitchenPrint) || 'NONE');
      setPaymentPrint((cloverWebhook && cloverWebhook.paymentPrint) || 'NONE');
      setShouldBeTriggerPrint((cloverWebhook && cloverWebhook.shouldBeTriggerPrint) || false);
      setPrintKitchenPrintAfterPayment((cloverWebhook && cloverWebhook.printKitchenPrintAfterPayment) || false);
      setPrintPaymentPrintAfterPayment((cloverWebhook && cloverWebhook.printPaymentPrintAfterPayment) || false);
    }
    if (!validator && redirect) {
      history && history.push(PAGES.INTEGRATIONS);
    }
  }, [validator, cloverWebhook]);

  if (loader) {
    return <Loading />;
  }

  const handleChange = () => {
    setEnable(!enable);
  };

  const handleInventory = () => {
    setAllowInventory(!allowInventory);
  };

  const handleOrder = () => {
    setAllowOrder(prevState => !prevState);
  };

  const handlePushOrderToClover = () => {
    setPushInventoryOrderToClover(!pushInventoryOrderToClover);
  };

  const handlePushOnlineOrderToClover = (value) => {
    setPushOnlineOrderToClover(value);
  };

  const handlePushDineInOrderToClover = (value) => {
    setPushDineInOrderToClover(value);
  };

  const handlePushCloverNotificationForNonCloverOrders = () => {
    setPushCloverNotificationForNonCloverOrders(!pushCloverNotificationForNonCloverOrders);
  };

  const handleKitchenPrint = (value) => {
    setKitchenPrint(value);
  };

  const handlePaymentPrint = (value) => {
    setPaymentPrint(value);
  };

  const handleShouldBeTriggerPrint = () => {
    setShouldBeTriggerPrint(!shouldBeTriggerPrint);
  };

  const handlePrintKitchenPrintAfterPayment = () => {
    setPrintKitchenPrintAfterPayment(!printKitchenPrintAfterPayment);
  };

  const handlePrintPaymentPrintAfterPayment = () => {
    setPrintPaymentPrintAfterPayment(!printPaymentPrintAfterPayment);
  };
  return (
    <>
      <Card className="mb-2">
        <>
          <Row className="mt-3" type="flex" justify="end" gutter={[16, 16]}>
            <Col>
              <SpButton
                type="secondary"
                shape="round"
                className="mr-3"
                onClick={isEdit ? () => setIsEdit(false) : () => history && history.push(PAGES.INTEGRATIONS)}
              >
                { isEdit ? 'Cancel' : 'Close' }
              </SpButton>
              <SpButton
                type="primary"
                shape="round"
                onClick={isEdit ? () => addNewWebhook() : () => setIsEdit(true)}
              >
                {isEdit ? (cloverWebhook && cloverWebhook.gid ? 'Update' : 'Save') : 'Edit'}
              </SpButton>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-1">
            <Col span={8}>
              <SpText fontWeight="600">Merchant Clover ID</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Enter Merchant Clover ID"
                value={merchantId}
                disabled={!isEdit}
                onChange={(e) => setMerchantId(e.currentTarget.value)}
              />
              <SpError>
                {simpleValidator.current.message('merchant Id', merchantId, 'required')}
              </SpError>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-1">
            <Col span={8}>
              <SpText fontWeight="600">API Token</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Enter API Token"
                value={token}
                disabled={!isEdit}
                onChange={(e) => setToken(e.currentTarget.value)}
              />
              <SpError>
                {simpleValidator.current.message('token', token, 'required')}
              </SpError>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-1">
            <Col span={8}>
              <SpText fontWeight="600">API Key (Optional)</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Enter API Key"
                value={apiKey}
                disabled={!isEdit}
                onChange={(e) => setApiKey(e.currentTarget.value)}
              />
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-1">
            <Col span={8}>
              <SpText fontWeight="600">Ecommerce API Token (Optional)</SpText>
            </Col>
          </Row>
          <Row type="flex" justify="start" align="middle" className="mb-3">
            <Col span={8}>
              <Input
                placeholder="Ecommerce API Token"
                value={ecomApiToken}
                disabled={!isEdit}
                onChange={(e) => setEcomApiToken(e.currentTarget.value)}
              />
            </Col>
          </Row>
        </>
      </Card>
      <Card className="mb-2">
        <Collapse expandIconPosition="end" style={{ border: 'none' }}>
          {/* eslint-disable-next-line max-len */}
          <Collapse.Panel header={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>Manage Clover Inventory</div>} style={{ borderBottom: 'none' }}>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '10px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <SpText fontWeight="600">Manage Clover Inventory from Swirepay</SpText>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <Select
                    style={{ minWidth: 200, width: 'auto' }}
                    value={manageInventory || 'Select Manage clover Inventory'}
                    onChange={(value) => setManageInventory(value)}
                    disabled={!isEdit}
                  >
                    <Option key={1} value="NONE">None</Option>
                    <Option key={2} value="MANAGE_PAYMENTS_PLAN">Manage Payments Plan</Option>
                    <Option key={3} value="MANAGE_ALL">Manage All</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('manage clover inventory', manageInventory, 'required')}
                  </SpError>
                </Col>
              </Row>
            </div>
            {allowBulkImport && (
            <Row type="flex" justify="start" align="middle" className="mt-4 mb-3">
              <Col span={8}>
                <SpButton
                  type="primary"
                  shape="round"
                  disabled={isEdit}
                  onClick={() => setConfirmBulkImport(true)}
                >
                  Bulk Import Clover Inventory
                </SpButton>
              </Col>
            </Row>
            )}
            {/* Warning Page */}
            {confirmBulkImport && (
            <Modal
              centered
              closable
              visible
              footer={null}
              onCancel={() => setConfirmBulkImport(false)}
              title={(
                <div style={{
                  fontFamily: 'Open Sans', fontStyle: 'normal', fontWeight: '700', fontSize: '16px', lineHeight: '22px',
                }}
                >Do you want to start the import?
                </div>
              )}
            >
              <div style={{
                paddingTop: '15px',
                paddingRight: '80px',
                paddingBottom: '130px',
                paddingLeft: '30px',
                fontFamily: 'Open Sans',
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '169.7%',
              }}
              >
                <div className="w-100">This Import job will run on background and will take some time to complete.</div>
                <div className="w-100"> The status of import job will be communicated via an email.</div>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '18px 28px 18px 275px',
                gap: '13px',
                position: 'absolute',
                width: '520px',
                height: '68px',
                left: '0px',
                top: '259px',
                background: '#FFFFFF',
                borderRadius: '0px 0px 8px 8px',
                zIndex: '9',
              }}
              >
                <SpButton onClick={() => setConfirmBulkImport(false)} type="secondary" style={{ marginRight: '10px' }}>Cancel</SpButton>
                <SpButton onClick={() => addBulkImportWebHook()}>Proceed</SpButton>
              </div>
            </Modal>
            )}
          </Collapse.Panel>
        </Collapse>
      </Card>
      <Card className="mb-2">
        <Collapse expandIconPosition="end" style={{ border: 'none' }}>
          {/* eslint-disable-next-line max-len */}
          <Collapse.Panel header={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>Merchant Webhooks</div>} style={{ borderBottom: 'none' }}>
            <Row type="flex" justify="start" align="middle" className="mb-3">
              <Col span={9}>
                <Switch
                  className="mb-1"
                  disabled={!isEdit}
                  checked={enable}
                  onChange={handleChange}
                />&nbsp;
                <SpText fontWeight="600">Enable Webhooks</SpText>
              </Col>
            </Row>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={allowInventory}
                  className="mr-2"
                  onChange={handleInventory}
                  disabled={!enable || !isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Inventory</SpText>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">When inventory items are created, updated, or deleted </SpText>
              </div>
            </div>
            <div
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={allowOrder}
                  className="mr-2"
                  onChange={handleOrder}
                  disabled={!enable || !isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Orders</SpText><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">When orders are created, updated, deleted </SpText>
              </div>
            </div>
          </Collapse.Panel>
        </Collapse>
      </Card>
      <Card className="mb-2">
        <Collapse expandIconPosition="end" style={{ border: 'none' }}>
          {/* eslint-disable-next-line max-len */}
          <Collapse.Panel header={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>Merchant Order Config</div>} style={{ borderBottom: 'none' }}>
            <Row type="flex" justify="start" align="middle" className="mb-3">
              <Col>
                <Switch
                  className="mb-1"
                  disabled={!isEdit}
                  checked={pushInventoryOrderToClover}
                  onChange={handlePushOrderToClover}
                />&nbsp;
                <SpText fontWeight="600">Push Inventory Order To Clover</SpText>
              </Col>
            </Row>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '10px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <SpText fontWeight="600">Online Order Push To Clover</SpText>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <Select
                    style={{ minWidth: 200, width: 'auto' }}
                    value={pushOnlineOrderToClover || 'Select online order push'}
                    onChange={handlePushOnlineOrderToClover}
                    disabled={!isEdit}
                  >
                    <Option key={1} value="NONE">None</Option>
                    <Option key={2} value="DURING_CREATION">During Creation</Option>
                    <Option key={3} value="DURING_PAYMENT">During Payment</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('order push', pushOnlineOrderToClover, 'required')}
                  </SpError>
                </Col>
              </Row>
            </div>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '10px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <SpText fontWeight="600">Dine In Order Push To Clover</SpText>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <Select
                    style={{ minWidth: 200, width: 'auto' }}
                    value={pushDineInOrderToClover || 'Select dine in order push'}
                    onChange={handlePushDineInOrderToClover}
                    disabled={!isEdit}
                  >
                    <Option key={1} value="NONE">None</Option>
                    <Option key={2} value="DURING_CREATION">During Creation</Option>
                    <Option key={3} value="DURING_PAYMENT">During Payment</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('order push', pushDineInOrderToClover, 'required')}
                  </SpError>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={pushCloverNotificationForNonCloverOrders}
                  className="mr-2"
                  onChange={handlePushCloverNotificationForNonCloverOrders}
                  disabled={!isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Clover Notifications For non-Clover Orders</SpText><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">For Trigger Notifications To Clover Devices</SpText>
              </div>
            </div>
          </Collapse.Panel>
        </Collapse>
      </Card>
      <Card className="mb-2">
        <Collapse expandIconPosition="end" style={{ border: 'none' }}>
          {/* eslint-disable-next-line max-len */}
          <Collapse.Panel header={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>Merchant Print Config</div>} style={{ borderBottom: 'none' }}>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '10px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <SpText fontWeight="600">Kitchen Print</SpText>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <Select
                    style={{ minWidth: 200, width: 'auto' }}
                    value={kitchenPrint || 'Select kitchen print'}
                    onChange={handleKitchenPrint}
                    disabled={!isEdit}
                  >
                    <Option key={1} value="NONE">None</Option>
                    <Option key={2} value="POS">Pos orders</Option>
                    <Option key={3} value="WEB">Web orders</Option>
                    <Option key={4} value="BOTH">Both pos and web orders</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('order push', kitchenPrint, 'required')}
                  </SpError>
                </Col>
              </Row>
            </div>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '10px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <SpText fontWeight="600">Payment Print</SpText>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle" className="mb-3">
                <Col>
                  <Select
                    style={{ minWidth: 200, width: 'auto' }}
                    value={paymentPrint || 'Select payment print'}
                    onChange={handlePaymentPrint}
                    disabled={!isEdit}
                  >
                    <Option key={1} value="NONE">None</Option>
                    <Option key={2} value="POS">Pos orders</Option>
                    <Option key={3} value="WEB">Web orders</Option>
                    <Option key={4} value="BOTH">Both pos and web orders</Option>
                  </Select>
                  <SpError>
                    {simpleValidator.current.message('order push', paymentPrint, 'required')}
                  </SpError>
                </Col>
              </Row>
            </div>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={shouldBeTriggerPrint}
                  className="mr-2"
                  onChange={handleShouldBeTriggerPrint}
                  disabled={!isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Should BE trigger print</SpText>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">For register plan, BE can trigger kitchen print</SpText>
              </div>
            </div>
            <div
              className="mb-3"
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={printKitchenPrintAfterPayment}
                  className="mr-2"
                  onChange={handlePrintKitchenPrintAfterPayment}
                  disabled={!isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Print kitchen print After payment</SpText><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">Only trigger kitchen print after payment</SpText>
              </div>
            </div>
            <div
              style={{
                border: '1px solid #d9d9d9', borderRadius: '5px', padding: '14px', maxWidth: '350px',
              }}
              type="flex"
              justify="start"
              align="left"
            >
              <div>
                <Checkbox
                  checked={printPaymentPrintAfterPayment}
                  className="mr-2"
                  onChange={handlePrintPaymentPrintAfterPayment}
                  disabled={!isEdit}
                />
              &nbsp;
                <SpText fontWeight="600">Print payment print After payment</SpText><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <SpText fontWeight="400" fontSize="11px">Only trigger payment print after payment</SpText>
              </div>
            </div>
          </Collapse.Panel>
        </Collapse>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  cloverWebhook: state.cloverWebhook,
  salesforceError: state.salesforce.salesforceError,
  loader: state.loading.loading,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  test: state.account.test,
});

const mapDispatchToProps = (dispatch) => ({
  updateCloverWebhook: param => dispatch(cloverWebhookActions.updateCloverWebhook({
    payload: param,
  })),
  fetchCloverWebhook: param => dispatch(cloverWebhookActions.fetchCloverWebhook({
    payload: param,
  })),
  addBulkImportWebHook: param => dispatch(cloverWebhookActions.addBulkImportWebHook({
    payload: param,
  })),
  deleteCloverWebhook: param => dispatch(cloverWebhookActions.deleteCloverWebhook({
    payload: param,
  })),
});


export default connect(mapStateToProps, mapDispatchToProps)(InternalCloverWebHook);
